import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import "./../../../css/app.css";
import useCheckMobileScreen from "./useCheckMobileScreen";

const Normal = (props) => {
  const mac = mqtt_topics.choosenmac; //"0-5b-96";
  const [state, setState] = useStateIfMounted({
    value: "---",
    unit: props.unit, //" --- "
    title: props.title, //"Normal UI"
    disabled: false, //if returned value == nv set to false
  });
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    mqtt_topics.Readings_topic +
    state.title;

  function listenforlivedata() {
    //console.log("target_live_reading_topic " + target_live_reading_topic);
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_live_reading_topic) {
      try {
        // message is Buffer
        //console.log(topic, "From Surf Mode: " + message.toString());
        message = JSON.parse(message.toString());

        if (message.value.toLowerCase().toString() == "nv") {
          setState({
            ...state,
            value: message.value == undefined ? "0" : message.value,
            disabled: true,
          });
        } else {
          setState({
            ...state,
            value: message.value == undefined ? "0" : message.value,
            disabled: false,
          });
        }
      } catch (error) {
        //console.log(message);
      }
    }
  }
  useEffect(() => {
    listenforlivedata();
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  return (
    <div className="col" style={{ display: state.disabled ? "none" : "block" }}>
      <div className="card text-center bg-light , normalcard">
        <div
          className="card-header"
          style={{
            backgroundColor: state.title.toLowerCase().includes("power")
              ? "#ffffbd"
              : "",
          }}
        >
          {state.title}
        </div>
        <div className="card-body">
          <h5
            className="card-title"
            style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}
          >
            {state.value}
          </h5>
        </div>
        <div className="card-footer">
          <strong style={{ fontSize: useCheckMobileScreen() ? "8px" : "12px" }}>
            {state.unit == undefined || state.unit == "" ? "---" : state.unit}
          </strong>
        </div>
      </div>
    </div>
  );
};
export default Normal;
